import { useEffect, useState } from 'react';

import { Alert } from '@simplywallst/ui-core';

type Props = {
  ticker: string;
};

export const SuccessAlert = ({ ticker }: Props) => {
  const [isHidden, setHidden] = useState(false);

  useEffect(() => {
    const dismissAlert = setTimeout(() => {
      setHidden(true);
    }, 3000);
    return () => clearTimeout(dismissAlert);
  }, []);

  if (isHidden) {
    return null;
  }

  return <Alert styleType="positive">{ticker} transaction saved</Alert>;
};
